<template>
  <BaseHybridLink v-bind="attrs"
                  v-on="$listeners"
                  :href="href"
                  :isRouterLink="isRouterLink"
                  :openInCurrentTab="openInCurrentTab"
                  :to="to">
    <slot />
  </BaseHybridLink>
</template>

<script>
  import BaseHybridLink from '@base/base-hybrid-link'
  import { FontStyle } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  const path = require('path');

  export default {
    name: 'HybridLinkNamePrimary',
    inheritAttrs: false,
    components: {
      BaseHybridLink,
    },
    props: {
      isRouterLink: { type: Boolean, required: false, default: false },
      openInCurrentTab: { type: Boolean, required:false, default: false },
      tenantUserId: { type: Number, required: false, default: () => null },
    },
    data: function () {
      return {
        attrs: {
          backgroundColor: 'none',
          border: 'none',
          borderRadius: 'none',
          borderWidth: 'none',
          cursor: { '': 'pointer', disabled: 'default' },
          display: 'inline-block',
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.lg,
          fontWeight: FontStyle.weight.xl,
          width: '100%',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        color: {
          '': this.color.dark2(),
          hover: this.color.action1(),
          active: this.color.action1(),
        },
        textDecoration: {
          '': 'none',
          hover: `solid underline ${this.color.action1()} 1px`,
          active: `solid underline ${this.color.action1()} 1px`,
        },
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        tenantDomain: state => state.tenant.domain,
      }),
      href: function () {
        return this.isRouterLink ? null : `${path.join(process.env.BASE_URL, 'users', this.tenantUserId.toString())}`;
      },
      to: function () {
        return this.isRouterLink ? { name: 'user', params: { id: this.tenantUserId } } : {};
      },
    },
  }
</script>

